import { type FC, useState } from "react";

import Input, { type InputProps } from "@/components/flowbite/forms/fields/input/input";
import { EyeCloseIcon } from "@/components/icons/eye-close.deprecated";
import { EyeOpenIcon } from "@/components/icons/eye-open.deprecated";

const PasswordInput: FC<InputProps> = ({ ...props }) => {
  const [isHidden, setIsHidden] = useState(true);

  return (
    <Input
      {...props}
      autoComplete="off"
      icon={(
        <button
          className="absolute inset-y-0 right-2.5 flex items-center text-text-secondary"
          type="button"
          onClick={() => setIsHidden((prev) => !prev)}
          onMouseDown={(e) => e.preventDefault()}
        >
          {isHidden ? <EyeCloseIcon /> : <EyeOpenIcon />}
        </button>
      )}
      type={isHidden ? "password" : "text"}
    />
  );
};

export default PasswordInput;
